import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';

import { connect } from 'react-redux';
import * as actions from '../actions';
import { NotificationContainer } from 'react-notifications';

import Toggle from 'react-toggle'
import "react-toggle/style.css"

import moment from 'moment'
import Datatable from 'react-bs-datatable';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};



class PollWorker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tofuIsReady: false,
      role: '1',
      poll_workerCMg: [],
      selectedContituency: "",
      selectedPollingDiv: "",
      selectedStreet: "",
      v_id: ""
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(id) {
    this.setState({
      modalIsOpen: true,
      v_id: id
    });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    //Get Polling Division Name
    if (nextProps.poll_workerCMg !== prevState.poll_workerCMg) {
      return { poll_workerCMg: nextProps.poll_workerCMg };
    }
    else return null;
  }

  componentDidMount() {
    this.props.listConsituency();

    this.props.getPWByManager()
  }

  componentWillMount() {

    this.setState({
      role: localStorage.getItem('role')
    })
    console.log(localStorage.getItem('role'))

  }
  //On constituency Changed
  ConstituencyChanged = e => {
    var qryString = "";
    console.log('Constituency');
    console.log(e.target.value);
    if (e.target.value == '') {
      this.setState({ selectedContituency: e.target.value, selectedStreet: '' })
      this.props.getPollingDiv(e.target.value);
      this.props.getSteet();
      this.props.getPWByManager(qryString);


    } else {

      this.setState({ selectedContituency: e.target.value })
      this.props.getPollingDiv(e.target.value);
      qryString = '?constituencyID=' + e.target.value;
      this.props.getPWByManager(qryString);
    }
  };
  PollingDivChanged = e => {
    var qryString = "";
    if (e.target.value == '') {
      this.setState({ selectedPollingDiv: e.target.value, selectedStreet: '' })
      this.props.getSteet();
      qryString = '?constituencyID=' + this.state.selectedContituency;
      this.props.getPWByManager(qryString);


    } else {

      this.setState({ selectedPollingDiv: e.target.value })
      this.props.getSteet(e.target.value);
      qryString = '?constituencyID=' + this.state.selectedContituency + '&pollingDivisionID=' + e.target.value;
      this.props.getPWByManager(qryString);
    }
  };
  //On street Changed
  streetChanged = e => {
    var qryString = "";
    if (e.target.value == '') {
      this.setState({ selectedStreet: e.target.value })
      qryString = '?constituencyID=' + this.state.selectedContituency + '&pollingDivisionID=' + this.state.selectedPollingDiv;

      this.props.getPWByManager(qryString);

    } else {

      this.setState({ selectedStreet: e.target.value })
      qryString = '?constituencyID=' + this.state.selectedContituency + '&pollingDivisionID=' + this.state.selectedPollingDiv + '&streetID=' + e.target.value;

      this.props.getPWByManager(qryString);

    }
  }
  render() {
    console.log('**********')
    console.log(this.props.street_list)
    const header = [

      { title: 'Name', prop: 'name', sortable: true },
      {
        title: 'Active Since',
        prop: 'createdAt',
        cell: row => moment(row.createdAt).format('Do MMMM YYYY'),
        sortable: true
      },
      {
        title: 'Last Active',
        prop: 'updatedAt',
        cell: row => moment(row.updatedAt).format('Do MMMM YYYY'),
        sortable: true
      },
      {
        title: 'Constituency',
        prop: 'constituency',
        cell: row => row.constituencyID ? row.constituencyID.constituencyName : null,
        sortable: true
      },
      { title: 'Total Data To Verify', prop: 'totalDataToVerify', sortable: true },
      { title: 'Total Verified', prop: 'totalSurvey', sortable: true },
      {
        title: 'Action',
        prop: 'action2',
        cell: row => <div
          style={{ width: '160px' }}>

          <button class="btn_cust btn-danger pull-left mr-3" onClick={() => this.openModal(row._id)}>
            <i class="fa fa-trash"></i>
          </button>
        </div>
      },
      {
        title: 'Block Worker from Accessing Application',
        prop: 'is_active',
        cell: row => <Toggle
          defaultChecked={row.is_active}
          onChange={() => this.props.pollWorkerStatusUpdate(row._id, row.is_active, 'p')} />
      },
    ];



    const body = [
      {
        sn: '1',
        name: 'Pushpendra',
        activesince: '10 August, 2019',
        lastactive: '25 September, 2019',
        constituency: 'constituency name',
        dataverify: '52',
        verified: '22',
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
        action2: <div style={{ width: '160px' }}><button class="btn_cust btn-primary pull-left mr-3"><i class="fa fa-edit"></i></button><button class="btn_cust btn-danger pull-left mr-3"><i class="fa fa-trash"></i></button></div>,
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
      },
      {
        sn: '1',
        name: 'Pushpendra',
        activesince: '10 August, 2019',
        lastactive: '25 September, 2019',
        constituency: 'constituency name',
        dataverify: '52',
        verified: '22',
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
        action2: <div style={{ width: '160px' }}><button class="btn_cust btn-primary pull-left mr-3"><i class="fa fa-edit"></i></button><button class="btn_cust btn-danger pull-left mr-3"><i class="fa fa-trash"></i></button></div>,
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
      },
      {
        sn: '1',
        name: 'Pushpendra',
        activesince: '10 August, 2019',
        lastactive: '25 September, 2019',
        constituency: 'constituency name',
        dataverify: '52',
        verified: '22',
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
        action2: <div style={{ width: '160px' }}><button class="btn_cust btn-primary pull-left mr-3"><i class="fa fa-edit"></i></button><button class="btn_cust btn-danger pull-left mr-3"><i class="fa fa-trash"></i></button></div>,
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
      },
      {
        sn: '1',
        name: 'Pushpendra',
        activesince: '10 August, 2019',
        lastactive: '25 September, 2019',
        constituency: 'constituency name',
        dataverify: '52',
        verified: '22',
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
        action2: <div style={{ width: '160px' }}><button class="btn_cust btn-primary pull-left mr-3"><i class="fa fa-edit"></i></button><button class="btn_cust btn-danger pull-left mr-3"><i class="fa fa-trash"></i></button></div>,
        action: <Toggle
          defaultChecked={this.state.tofuIsReady}
          icons={false}
          onChange={this.handleTofuChange} />,
      },

    ];

    const onSortFunction = {
      date(columnValue) {
        return moment(columnValue, 'Do MMMM YYYY').valueOf();
      },
    };

    const customLabels = {
      first: '<<',
      last: '>>',
      prev: '<',
      next: '>',
      show: 'Display',
      entries: 'rows',
      noResults: 'There is no data to be displayed',
    };



    return (
      <div>
        <div className="container-fluid">
          <div className="row my-3 px-4 printRow">
            <NotificationContainer />
            <div className="col-sm-4 printfleft">
              <h1 className="text-primary ">Poll Worker</h1>
            </div>

            <Modal
              isOpen={this.state.modalIsOpen}
              onRequestClose={false}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="modal_head">
                <h1 className="text-primary "> Delete Poll Worker </h1>
                <button className="btn_close" onClick={this.closeModal}>
                  {' '}
                  x{' '}
                </button>
              </div>

              <div className="modal_body form-horizontal">
                <div className="mb-3">
                  <label>
                    {`Are you sure, do you want to permanently delete this worker ?`}
                  </label>
                </div>

                <div className=" mb-3">
                  <div className="offset-4 col-sm-8">
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => this.props.pollWorkerDelete(this.state.v_id, 'p')}
                    >
                      {' '}
                      Delete{' '}
                    </button>
                  </div>
                </div>
              </div>
            </Modal>



            <div className="col-sm-8 printfleft">
              <div className="title_right_sec">

                <div className="form-inline mr-3 mb-3">
                  <label className="mr-2">Filter By</label>
                  <select
                    className="form-control pull-right"
                    id="const_sele"
                    name="consti"
                    onChange={this.ConstituencyChanged}
                    value={this.state.selectedContituency}
                  >
                    <option value="">Select a Constituency</option>
                    {this.props.constituency_list.map((data, index) => {
                      return (
                        <option value={data._id}>
                          {data.constituencyName}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group mr-3">
                  <select className="form-control pull-right"
                    onChange={this.PollingDivChanged}
                    value={this.state.selectedPollingDiv}
                  >
                    <option value="">Select Polling div</option>
                    {this.props.polling_div.map((data, index) => {
                      return (
                        <option value={data._id}>
                          {data.pollingDivisionName}
                        </option>
                      );
                    })}
                  </select>
                </div>


                <div className="form-group">
                  <select className="form-control pull-right"
                    onChange={this.streetChanged}
                    value={this.state.selectedStreet}
                  >
                    <option value="">Select Street</option>
                    {this.props.street_list.map((data, index) => {
                      return (
                        <option value={data._id}>
                          {data.street_name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group printHide">
                  <button class="btn_cust btn-primary ml-3"  onClick={() => window.print()}>Download and Print Report</button>
                </div>
              </div>
            </div>

          </div>


          <div className="row mt-5 px-4">

            <div className="col-sm-12 mb-4 printHide">
              <div className="shadow_box custom_datatable">
                <Datatable
                  tableHeader={header}
                  tableBody={this.state.poll_workerCMg}
                  keyName="userTable"
                  tableClass="striped hover responsive"
                  rowsPerPage={5}
                  rowsPerPageOption={[5, 10, 15, 20]}
                  initialSort={{ prop: "username", isAscending: true }}
                  onSort={onSortFunction}
                  labels={customLabels}
                />
              </div>
            </div>

            
            <div className="printTable"> 
          <table border="1" cellPadding="10">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Name</th>
                <th>Active Since</th>
                <th>Last Active</th>
                <th>Constituency</th>
                <th>Total Data To Verify</th>
                <th>Total Verified</th>
              </tr>
            </thead>
            <thead>

              {this.state.poll_workerCMg.map((data, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{data.name}</td>
                      <td>{data.createdAt}</td>
                      <td>{data.updatedAt} </td>
                      <td>{data.pollingDivisionID.pollingDivisionName}</td>
                  <td>{data.totalDataToVerify}</td>
                      <td>{data.totalSurvey}</td>
                    </tr>
                  )
                })
              }
            </thead>
          </table>
        </div>


          </div>


        </div>


      </div>
    )
  }
}

const mapStateToProps = ({ authUser, campTeam, survey }) => {
  const { user, isAuthenticated } = authUser;
  const { loading, constituency_list, polling_div, poll_workerCMg } = campTeam;
  const { street_list } = survey;

  return { user, loading, isAuthenticated, constituency_list, polling_div, street_list, poll_workerCMg }
}
export default connect(mapStateToProps, actions)(PollWorker);

